"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyGetListApi = companyGetListApi;
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.orderDeleteApi = orderDeleteApi;
exports.orderDetailApi = orderDetailApi;
exports.orderListApi = orderListApi;
exports.orderListDataApi = orderListDataApi;
exports.orderLogApi = orderLogApi;
exports.orderMarkApi = orderMarkApi;
exports.orderPrint = orderPrint;
exports.orderRefundApi = orderRefundApi;
exports.orderRefuseApi = orderRefuseApi;
exports.orderSendApi = orderSendApi;
exports.orderStatisticsApi = orderStatisticsApi;
exports.orderStatusNumApi = orderStatusNumApi;
exports.orderTimeApi = orderTimeApi;
exports.orderUpdateApi = orderUpdateApi;
exports.sheetInfoApi = sheetInfoApi;
exports.statisticsDataApi = statisticsDataApi;
exports.updatePriceApi = updatePriceApi;
exports.videoSendApi = videoSendApi;
exports.writeConfirmApi = writeConfirmApi;
exports.writeUpdateApi = writeUpdateApi;

var _request = _interopRequireDefault(require("@/utils/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 订单 列表
 * @param prams
 */
function orderListApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/list',
    method: 'get',
    params: params
  });
}
/**
 * 订单 列表 获取各状态数量
 * @param params
 */


function orderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/status/num',
    method: 'get',
    params: params
  });
}
/**
 * 订单 列表 数据统计
 * @param params
 */


function orderListDataApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/list/data',
    method: 'get',
    params: params
  });
}
/**
 * 订单 删除
 * @param params
 */


function orderDeleteApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/delete',
    method: 'get',
    params: params
  });
}
/**
 * 订单 编辑
 * @param prams
 */


function orderUpdateApi(data, params) {
  return (0, _request.default)({
    url: '/admin/store/order/update',
    method: 'post',
    data: data,
    params: params
  });
}
/**
 * 订单 记录
 * @param prams
 */


function orderLogApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/status/list',
    method: 'get',
    params: params
  });
}
/**
 * 订单 详情
 * @param prams
 */


function orderDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/info',
    method: 'get',
    params: params
  });
}
/**
 * 订单 备注
 * @param prams
 */


function orderMarkApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/mark',
    method: 'post',
    params: params
  });
}
/**
 * 订单 发货
 * @param prams
 */


function orderSendApi(data) {
  return (0, _request.default)({
    url: '/admin/store/order/send',
    method: 'post',
    data: data
  });
}
/**
 * 订单 拒绝退款
 * @param prams
 */


function orderRefuseApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/refund/refuse',
    method: 'get',
    params: params
  });
}
/**
 * 订单 立即退款
 * @param prams
 */


function orderRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/refund',
    method: 'get',
    params: params
  });
}
/**
 * 订单 核销订单
 * @param prams
 */


function writeUpdateApi(vCode) {
  return (0, _request.default)({
    url: "/admin/store/order/writeUpdate/".concat(vCode),
    method: 'get'
  });
}
/**
 * 订单 核销码查询待核销订单
 * @param prams
 */


function writeConfirmApi(vCode) {
  return (0, _request.default)({
    url: "/admin/store/order/writeConfirm/".concat(vCode),
    method: 'get'
  });
}
/**
 * 订单 统计 头部数据
 */


function orderStatisticsApi() {
  return (0, _request.default)({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}
/**
 * 核销订单 月列表数据
 */


function statisticsDataApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/statisticsData",
    method: 'get',
    params: params
  });
}
/**
 * 一键改价
 */


function updatePriceApi(data) {
  return (0, _request.default)({
    url: "admin/store/order/update/price",
    method: 'post',
    data: data
  });
}
/**
 *订单统计详情
 */


function orderTimeApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/time",
    method: 'get',
    params: params
  });
}
/**
 *面单默认配置信息
 */


function sheetInfoApi() {
  return (0, _request.default)({
    url: "/admin/store/order/sheet/info",
    method: 'get'
  });
}
/**
 *面单默认配置信息
 */


function getLogisticsInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/getLogisticsInfo",
    method: 'get',
    params: params
  });
}
/**
 *视频号物流公司
 */


function companyGetListApi() {
  return (0, _request.default)({
    url: "/admin/pay/component/delivery/company/get/list",
    method: 'get'
  });
}
/**
 *视频号物流公司
 */


function videoSendApi(data) {
  return (0, _request.default)({
    url: "/admin/store/order/video/send",
    method: 'post',
    data: data
  });
}
/**
 *打印小票
 */


function orderPrint(id) {
  return (0, _request.default)({
    url: "/admin/yly/print/".concat(id),
    method: 'get'
  });
}